export var ClientNames;
(function (ClientNames) {
    ClientNames["designs_ai"] = "Designs AI";
    ClientNames["logomaker"] = "Logomaker";
    ClientNames["videomaker"] = "Videomaker";
    ClientNames["designmaker"] = "Designmaker";
    ClientNames["mockupmaker"] = "Mockupmaker";
    ClientNames["speechmaker"] = "Speechmaker";
    ClientNames["imagemaker"] = "Imagemaker";
    ClientNames["faceswapper"] = "Faceswapper";
    ClientNames["fontpairer"] = "Font Pairer";
    ClientNames["graphicmaker"] = "Graphicmaker";
    ClientNames["color_matcher"] = "Color Matcher";
    ClientNames["calendar"] = "Calendar";
    ClientNames["copywriter"] = "Copywriter";
    ClientNames["ai_draw"] = "AI Draw";
    ClientNames["ai_chat"] = "AI Chat";
    ClientNames["ai_audio"] = "AI Audio";
    ClientNames["ai_design"] = "AI Design";
})(ClientNames || (ClientNames = {}));
//# sourceMappingURL=client-names.enum.js.map